export default __webpack_public_path__ + "static/media/Assembly Both Ways.2ca061bd.webp";